const state = {
    selectedUser: null, //stores the selected user(used in form modal)
    formUser: null,
    userShow: false, //show=true | edit=false
    showUserModal: false,//controls if the form modal is displayed or not
    showChangePasswordModal: false,//controls if the form modal is displayed or not
    showChangeLoggedUserPasswordModal: false,//controls if the form modal is displayed or not
};

const getters = {
    getSelectedUser(state, getters){
        if(!state.selectedUser){
            state.selectedUser = getters.getNewUser;
        }
        return state.selectedUser;
    },
    getFormUser(stae, getters){
        if(!state.formUser){
            state.formUser = getters.getEmptyFormUser;
        }
        return state.formUser;
    },
    getUserShow(state){
        return state.userShow;
    },
    getShowUserModal(state){
        return state.showUserModal;
    },
    getShowChangePasswordModal(state){
        return state.showChangePasswordModal;
    },
    getShowChangeLoggedUserPasswordModal(state){
        return state.showChangeLoggedUserPasswordModal;
    },

    getNewUser(){
        return {
            id: '',
            name: '',
            email: '',
            bi: '',
            groups_id: '',
            companies_id: '',
            access: 0,
            email_contact: '',
            address: '',
            phone: '',
            image: '',
            password: '',
        };
    },

    getEmptyFormUser(){
        return {
            id: '',
            name: '',
            email: '',
            bi: '',
            groups_id: '',
            companies_id: '',
            access: 0,
            email_contact: '',
            address: '',
            phone: '',
            image: '',
            password: '',
        }
    }

};

const mutations = {
    setSelectedUser(state, payload){ //this also works for new article
        state.selectedUser = payload;
    },
    setFormUser(state, payload){ //this also works for new article
        state.formUser = payload;
    },

    setPreparedFormUser(state, payload){
        state.formUser = {
            id: payload ? payload.id : '',
            name: payload ? payload.name : '',
            email: payload ? payload.email : '',
            bi: payload ? payload.bi : '',
            groups_id: payload ? payload.groups_id : '',
            companies_id: payload ? payload.companies_id : '',
            email_contact: payload ? payload.email_contact : '',
            address: payload ? payload.address : '',
            phone: payload ? payload.phone : '',
            access: payload ? payload.access : 0,
            image: payload ? payload.image : '',
            password: payload ? payload.password : '',
        };
    },

    setUserShow(state, payload){ //this also works for new article
        state.userShow = payload;
    },
    setShowUserModal(state, payload){
        state.showUserModal = payload;
    },
    setShowChangePasswordModal(state, payload){
        state.showChangePasswordModal = payload;
    },
    setShowChangeLoggedUserPasswordModal(state, payload){
        state.showChangeLoggedUserPasswordModal = payload;
    }
};

const actions = {
    setSelectedUser( {commit}, payload){
        commit('setSelectedUser', payload);
        commit('setPreparedFormUser', payload);
    },

    setUserShow({commit}, payload){
        commit('setUserShow', payload);
    },
    setShowUserModal({commit}, payload){
        commit('setShowUserModal', payload);
    },
    setShowChangePasswordModal({commit}, payload){
        commit('setShowChangePasswordModal', payload);
    },
    setShowChangeLoggedUserPasswordModal({commit}, payload){
        commit('setShowChangeLoggedUserPasswordModal', payload);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};

